import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/contacts', { params }),
  getById: id => axios.get(`/api/admin/v1/contacts/${id}`),
  create: contact => axios.post('/api/admin/v1/contacts', contact),
  update: contact => axios.put('/api/admin/v1/contacts', contact),
  delete: id => axios.delete(`/api/admin/v1/contacts/${id}`),

  // Тот же QR-код, что показывает сайт: format — Svg или Png.
  getAppQr: format => axios.get('/api/web/v1/app-download/qr', { params: { format }, responseType: 'blob' }),
}
